import React from "react";
import { RecallType } from "../../piping/RecallType";
import useRecall from "../../hooks/useRecall";

interface Props {
    text: string;
    type?: RecallType;
    render?(recalled: string): JSX.Element;
}

export function RecalledText(props: Props) {
    const { text, type, render } = props;
    const recalled = useRecall(text, type);

    if (render) {
        return render(recalled);
    }
    return <span dangerouslySetInnerHTML={{ __html: recalled }} />;
}
